import type { ButtonHTMLAttributes } from "react";

type Variant = "primary" | "secondary" | "ghost";

const variants: Record<Variant, string> = {
  primary:
    "border border-[var(--accent)]/30 bg-[var(--accent)] text-[var(--accent-foreground)] shadow-[inset_0_1px_0_rgba(255,255,255,0.18),inset_0_-1px_0_rgba(0,0,0,0.1),0_8px_28px_-10px_rgba(94,207,255,0.45)] hover:bg-[var(--accent-hover)] hover:border-[var(--accent)]/40 hover:shadow-[inset_0_1px_0_rgba(255,255,255,0.2),0_10px_32px_-10px_rgba(94,207,255,0.55)] disabled:opacity-50",
  secondary:
    "border border-[var(--border-strong)]/70 bg-[var(--surface-elevated)] text-[var(--foreground)] shadow-[var(--shadow-inset-top),0_1px_3px_rgba(0,0,0,0.2)] hover:border-[var(--border-strong)] hover:bg-[var(--surface-3)] hover:shadow-[var(--shadow-inset-top),0_2px_6px_rgba(0,0,0,0.25)] disabled:opacity-50",
  ghost:
    "border border-transparent text-[var(--muted-foreground)] hover:border-[var(--border)] hover:bg-[var(--surface)]/70 hover:text-[var(--foreground)] disabled:opacity-50",
};

const base =
  "inline-flex min-h-11 cursor-pointer touch-manipulation select-none items-center justify-center rounded-[0.5rem] px-5 py-2.5 text-sm font-medium transition-[color,background-color,border-color,box-shadow,transform] duration-150 active:scale-[0.985] active:brightness-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--bg)] disabled:cursor-not-allowed disabled:active:scale-100";

export function Button({
  variant = "primary",
  className = "",
  type = "button",
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant }) {
  return <button type={type} className={`${base} ${variants[variant]} ${className}`} {...rest} />;
}
